// 引入组件
import footComponent from "components/content/Foot";	// footer


export default {
  footComponent
}
